<template>
  <el-row>

    <el-col :span="24">
      <div class="leftnav" :style="{ 'height': ileftHeight + 'px' }">
        <el-tree :expand-on-click-node="false"   :data="options"  
          @current-change="currentChange"></el-tree>
      </div>
      <div class="main" :style="{ 'height': ibHeight + 'px' }">
        <el-row class="mainbox">
          <el-col :span="24">
            <el-col :span="24">
              <el-col :span="24">
                <el-form :inline="true" :model="where" class="demo-form-inline searchbox">
                  <el-form-item label="关键词：">
                    <el-input v-model="keyword" prefix-icon="el-icon-search" @keyup.native.enter="query"
                      placeholder="请输入检索内容等查询..."></el-input>
                  </el-form-item>

                  <el-button style="margin-left:10px;" icon="el-icon-search" type="success"
                    @click="query">快速查询</el-button>

                  <el-button style="margin-left:10px;" icon="el-icon-plus" type="primary"
                    @click="addkongzhigui">新增客户</el-button>
                </el-form>
              </el-col>


            </el-col>
            <el-col :span="24" style="background:rgba(0,217,255,.15);padding:10px; ">
              <el-row>

                <el-col :span="24">

                  <el-table :data="tabledata" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                    <el-table-column fixed type="index" align="center" label="序号" width="50">
                    </el-table-column>
                    <el-table-column fixed prop="schoolname" label="客户名称" min-width="200">
                    </el-table-column>
                    <el-table-column fixed prop="kehujc" label="客户简称" min-width="200">
                    </el-table-column>
                    <el-table-column prop="areastr" label="所属政区" align="center" min-width="200">
                    </el-table-column>
                    <el-table-column prop="contacts" label="联系人" align="center" width="100">
                    </el-table-column>
                    <el-table-column prop="tel" label="手机" align="center" width="120">
                    </el-table-column>
                    <el-table-column prop="typedesc" label="客户类型" align="center" min-width="100">
                    </el-table-column>
                    <el-table-column prop="areatypedesc" label="保护类型" align="center" min-width="100">
                    </el-table-column>
                    <el-table-column prop="hezuokssjdesc" label="合同开始日期" align="center" min-width="120">
                    </el-table-column>
                    <el-table-column prop="hezuodqsjdesc" label="合同到期日期" align="center" min-width="120">
                    </el-table-column>

                    <el-table-column prop="createtime" label="创建日期" align="center" width="180">
                    </el-table-column>


                    <el-table-column prop="caozuo" label="操作" fixed="right" width="180" align="center">
                      <template slot-scope="scope">
                        <el-button @click="editbtn(scope.row)" type="warning" size="small">编辑</el-button>
                        <el-button @click="delbtn(scope.row)" type="danger" size="small">删除</el-button>

                      </template>
                    </el-table-column>
                  </el-table>

                </el-col>
                <el-col style="margin-top:10px;text-align:center;">
                  <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
                    :page-size="limit" :total="total">
                  </el-pagination>
                </el-col>

              </el-row>

            </el-col>
          </el-col>
        </el-row>
      </div>
    </el-col>
    <el-dialog title="" :visible.sync="editqiyeFlag" width="1400px" :close-on-click-modal="false"
      :close-on-press-escape="false" :modal-append-to-body="false" :show-close="false">
      <el-row style="    margin-top: -40px;">
        <el-col :span="24" class="stoptitle">
          {{ editqiyeFrom.id == 0 ? '新增客户' : '编辑客户' }}
        </el-col>
        <el-form :model="editqiyeFrom" :rules="editqiyeFromRules" ref="editqiyeFrom" label-width="100px">

          <el-col :span="24" style="margin-top:10px">

            <el-form-item label="客户名称" prop="schoolname">
              <el-input v-model="editqiyeFrom.schoolname"></el-input>
            </el-form-item>
            <el-form-item label="客户简称" prop="kehujc">
              <el-input v-model="editqiyeFrom.kehujc"></el-input>
            </el-form-item>
            <el-form-item label="客户地址" prop="addr">
              <el-input v-model="editqiyeFrom.addr"></el-input>
            </el-form-item>
            <el-form-item label="所属地区" prop="area">
              <el-cascader style="width: 100%;" @change="cascaderchange" size="large" :options="ssxxdata"
                v-model="editqiyeFrom.area" :props="{ label: 'label', value: 'label' }">
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户联系人" prop="contacts">
              <el-input v-model="editqiyeFrom.contacts"></el-input>
            </el-form-item>
            <el-form-item label="合同开始时间" prop="hezuokssj">
              <el-date-picker
                style="width: 100%;"
                v-model="editqiyeFrom.hezuokssj"
                type="date"
                placeholder="选择合同开始时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="客户类型" prop="type">
              <el-radio-group v-model="editqiyeFrom.type" >
                <el-radio :label="1">VIP客户</el-radio>
                <el-radio :label="2">独家客户</el-radio>
                <el-radio :label="3">普通客户</el-radio>
                <el-radio :label="4">合伙人</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系手机" prop="tel">
              <el-input v-model="editqiyeFrom.tel"></el-input>
            </el-form-item>
            <el-form-item label="合同结束时间" prop="hezuodqsj">
              <el-date-picker
              style="width: 100%;"
                v-model="editqiyeFrom.hezuodqsj"
                type="date"
                placeholder="选择合同结束时间">
              </el-date-picker>
            </el-form-item>
            
          </el-col>
          <el-col :span="24">
            <el-form-item label="保护类型" prop="areatype">
              <el-radio-group v-model="editqiyeFrom.areatype" >
                <el-radio :label="9">市级全域</el-radio>
                <el-radio :label="1">县级全域</el-radio>
                <el-radio :label="2">4KM</el-radio>
                <el-radio :label="3">3KM</el-radio>
                <el-radio :label="4">2KM</el-radio>
                <el-radio :label="5">1KM</el-radio>
                <el-radio :label="6">500M</el-radio>
                <el-radio :label="7">250M</el-radio>
                <el-radio :label="8">无保护</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="位置检索" prop="keyword">
              <el-input @blur="searchMap" @keydown.enter="searchMap" v-model="editqiyeFrom.keyword"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div id="editcontainer"></div>
            <div id="panel"></div>
          </el-col>
        </el-form>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editqiyeFlag = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('editqiyeFrom')">确 定</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import { provinceAndCityData } from 'element-china-area-data'
import { editschool, school_getinfo, school_list, school_del, getallarea } from '../api/api'
 

export default {
  data() {
    return {
      loading: false,
      keyword: '',
      ssxxdata: [],
   
      tabledata: [],
      total: 0,
      limit: 10,
      page: 1,
      editqiyeFlag: false,
      editqiyeFrom: {
        id:null,
        addr:'',
        kehujc:'',
        schoolname: '',
        area: [],
        contacts: '',
        hezuokssj: null,
        type: null,
        tel: '',
        hezuodqsj: null,
        areatype: null,
        jingdu:null,
        weidu:null,
        sheng:null,
        shi:null,
        xian:null,
        xiang:null

      },
      editqiyeFromRules: {
        schoolname: [
          { required: true, message: '请输入客户名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        kehujc: [
          { required: true, message: '请输入客户简称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        addr: [
          { required: true, message: '请输入客户地址', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        contacts: [
          { required: true, message: '请输入客户联系人', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],

        tel: [
          { required: true, message: '请输入客户联系人电话', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        hezuokssj: [
          { required: true, message: '请选择客户合同开始时间', trigger: 'change' }
        ],
        hezuodqsj: [
          { required: true, message: '请选择客户合同到期时间', trigger: 'change' }
        ],
        area: [
          { required: true, message: '请选择客户所在政区', trigger: 'change' }
        ],
        type: [
          { required: true, message: '请选择客户类型', trigger: 'change' }
        ],
        areatype: [
          { required: true, message: '请选择客户保护类型', trigger: 'change' }
        ],
      },
      selectedOptions: null,
      options: [],
      selectshengshi: '',
      where: null,
      map: null,
      marker: null,
      zhongxin: [110.804, 39.606],
      district: null,
      polygons: [],
      placeSearch: null,
      selectcity: null,

    };
  },
  computed: {
    ibHeight() {

      return window.innerHeight - 96;
    },
    ileftHeight() {

      return window.innerHeight - 126;
    },
  },
  created() {


    this.query();
    this.getallarea();
    this.getleftnav();
    
  },
  methods: {
    getallarea() {
      let that = this;
      getallarea().then(res => {
        that.ssxxdata = res.data;
      })
    },
    query() {
      let that = this;
      that.loading = true;
      school_list({ keyword: that.keyword, page: that.page, limit: that.limit, type: that.selectshengshi }).then(res => {

        that.tabledata = res.data.list;
        that.total = res.data.count;

        setTimeout(() => {
          that.loading = false;
        }, 200)

      })
    },
    getleftnav() {
      let that = this;
      school_getinfo().then(res => {
        console.log(res);
        that.options = res.data;
      })
    },
    handleCurrentChange(val) {
      this.page = val;
      this.query();
    },
    currentChange(val, tnt) {
      this.selectshengshi = val.id;
      this.query();
    },
    addkongzhigui() {
      this.editqiyeFlag = true;
      this.editqiyeFrom = {
        id:null,
        addr:'',
        schoolname: '',
        area: [],
        contacts: '',
        hezuokssj: null,
        type: null,
        tel: '',
        hezuodqsj: null,
        areatype: null,
        jingdu:null,
        weidu:null,
        sheng:null,
        shi:null,
        xian:null,
        xiang:null

      };

      let that = this;
      if (this.map == null) {
        setTimeout(() => {
          that.loadmap();
        }, 2000);
      }
    },
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(that.editqiyeFrom);
          debugger;
          if(!that.editqiyeFrom.jingdu ){
            this.$message({
              message: "请再地图上标记客户位置点",
              type: "error"
            });

            return false;
          }

          that.editqiyeFrom.sheng = that.editqiyeFrom.area[0];
          that.editqiyeFrom.shi = that.editqiyeFrom.area[1];
          that.editqiyeFrom.xian = that.editqiyeFrom.area[2];
          that.editqiyeFrom.xiang = that.editqiyeFrom.area[3];
          editschool( that.editqiyeFrom).then((res) => {
            that.editqiyeFlag = false;
            this.$message({
              message: "保存学校成功",
              type: "success"
            });
            that.query();
            that.getleftnav();
          }).catch(() => {
            this.$message({
              message: "保存学校失败",
              type: "error"
            });
          })

        } else {

          return false;
        }
      });

    },
    editbtn(row) {
      this.editqiyeFrom.id = row.id;
      this.editqiyeFrom.schoolname = row.schoolname;
      this.editqiyeFrom.area = row.area;

      this.editqiyeFrom.areatype = row.areatype;
      this.editqiyeFrom.contacts = row.contacts;
      this.editqiyeFrom.hezuodqsj = row.hezuodqsj;
      this.editqiyeFrom.hezuokssj = row.hezuokssj;
      this.editqiyeFrom.jingdu = row.jingdu;

      this.editqiyeFrom.weidu = row.weidu;
      this.editqiyeFrom.type = row.type;
      this.editqiyeFrom.addr = row.addr;
      this.editqiyeFrom.areatype = row.areatype;
      this.editqiyeFrom.tel = row.tel;

      this.editqiyeFlag = true;

      let that = this;
      if (this.map == null) {
        setTimeout(() => {
          that.loadmap();
        }, 2000);
      }

    },
    delbtn(row) {
      let that = this;
      this.$confirm("此操作将永久删除该客户信息，删除后则客户信息不可恢复，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {

          school_del({ id: row.id }).then(() => {
            this.$message({
              message: "删除客户成功",
              type: "success"
            });
            that.query();
            that.getleftnav();
          });

        })
        .catch(() => { });
    },
    searchMap() {
   
      if(!this.editqiyeFrom.keyword){
        return false;
      }

      let that = this;
      AMap.plugin('AMap.PlaceSearch', function () {
        var autoOptions = {
          city: that.selectcity,
          pageSize: 5, // 单页显示结果条数
          pageIndex: 1, // 页码

          citylimit: true,  //是否强制限制在设置的城市内搜索
          map: that.map, // 展现结果的地图实例
          panel: "panel", // 结果列表将在此容器中进行展示。
          autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
        }
        var placeSearch = new AMap.PlaceSearch(autoOptions);
          placeSearch.search(that.editqiyeFrom.keyword, function (status, result) {

        })
 
        AMap.event.addListener(placeSearch, "selectChanged", (res) => {
          that.markerfun(res);
        }); //返回结果

        AMap.event.addListener(placeSearch, "markerClick", (e)=>{
          // console.log("markerClick");
          // e.marker.setDraggable(true);
        }); //返回结果

      })
    },
    //修改政区后的change 事件
    cascaderchange(e) {
      console.log(e);
      
      let city =  e[2] ;
      if (city == "郊区") {
        city = e[1];
      } 

      this.selectcity =  e[1];

      console.log(this.selectcity);

      for (var i = 0, l = this.polygons.length; i < l; i++) {
        this.polygons[i].setMap(null);
      }

      let that = this;
      this.district.setLevel('district'); //行政区级别
      this.district.setExtensions('all');
      this.district.search(city, function (status, result) {
        if (status == 'complete') {
          console.log(result);
          //that.map.setZoomAndCenter(9,result.districtList[0].center);
          
          
          let bounds = result.districtList[0].boundaries;
          let zjitem = result.districtList[0].center;

          if(result.districtList.length>0){
            const xiangjd = e[3];
            result.districtList.forEach((item)=>{
              item.districtList.forEach((xiangzhen)=>{
                if(xiangzhen.name == xiangjd){
                  bounds = item.boundaries;
                  zjitem = item.center;
                  return false;
                }
              })
            })
          }


          if (bounds) {
            for (var i = 0, l = bounds.length; i < l; i++) {
              var polygon = new AMap.Polygon({
                map: that.map,
                strokeWeight: 1,
                strokeColor: '#0091ea',
                fillColor: '#80d8ff',
                fillOpacity: 0.2,
                path: bounds[i]
              });
              that.polygons.push(polygon);
            }
            that.map.setFitView();//地图自适应
            that.map.setZoomAndCenter(9, zjitem);
          }
        }
      });
    },
    markerfun(e) {
   
      const jingweidata = e.selected.data.location;
      this.editqiyeFrom.jingdu = jingweidata.lng;
      this.editqiyeFrom.weidu = jingweidata.lat;
    },
    loadmap() {

      let that = this;
      that.map = new AMap.Map('editcontainer', {
        zoom: 5,//级别
        center: that.zhongxin,//中心点坐标
        mapStyle: 'amap://styles/a1957ab716e8374961906fd797442322',

      });

      that.district = new AMap.DistrictSearch({
        subdistrict: 1,   //返回下一级行政区
        showbiz: false  //最后一级返回街道信息
      });

      that.marker.on('dragging', that.markerfun);

      that.map.on("click", function (e) {

        let lnglat = [e.lnglat.lng, e.lnglat.lat];
        let geocoder = new AMap.Geocoder({ radius: 1000 });
        geocoder.getAddress(lnglat, (status, result) => {
          if (status === "complete" && result.regeocode) {

            let shengf = result.regeocode.addressComponent.province;

            if (that.openshengf.indexOf(shengf) > -1) {
              that.map.setCenter(lnglat);
              that.map.setZoom(7);
              // that.selectsheng = shengf;

            }
          }
        });

      })
    }
  },
  mounted() {
  },
}
</script>

<style scoped></style>

<style scoped>
#editcontainer {
  overflow: hidden;
  width: 960px;
  height: 400px;
  display: inline-block;
  vertical-align: top;
}

#panel {
  width: 373px;
  height: 400px;
  display: inline-block;
  margin-left: 20px;
  border: 1px solid #00d5d1;
  vertical-align: top;
}
</style>

<style>
.amap_lib_placeSearch_page,
.amap_lib_placeSearch,
.amap_lib_placeSearch_list {
  background-color: transparent !important;
}

.amap_lib_placeSearch {
  color: #fff;
}

.poibox:hover {
  background: #409eff7a !important;
}

.el-radio .el-radio__label{
  color: #fff;
}
</style>
